export default __webpack_public_path__ + "static/media/Group 81311.86010a14.png";